import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/sections/Home";
import Loader from "./components/loader/Loader";
import WhyUs from "./components/sections/WhyUs";
import Footer from "./components/sections/Footer";
import Services from "./components/sections/services/Services";
import Clients from "./components/sections/clients/Clients";
import ItServices from "./components/sections/ItServices";
import ParallaxBg from "./components/ParallaxBg";

export default function MainPage() {
  return (
    <div className=" font-inter">
      <Navbar />
      <Home />
      <Services />
      <div className="hidden md:block ">
        <ParallaxBg />
      </div>

      <div className="px-4 xs:px-16 md:px-24 lg:px-40 xl:px-64 flex flex-col bg-white">
        <WhyUs />
      </div>
      <ItServices />
      <div className="px-4 xs:px-16 md:px-24 lg:px-40 xl:px-64 flex flex-col bg-white">
        <Clients />
      </div>

      <Footer />
    </div>
  );
}
